<template>
  <div>
    <loading
      v-if="loadingDataForEditing"
      :fullscreen="true"
    />
    <div class="orders-new_container input-forms">
      <collection-point-create-modal
        ref="collectionPointCreateModal"
        @collectPostCreated="collectionPostNameUpdate"
      />
      <modal
        ref="transferModal"
        template="loading"
        ref-name="transferModal"
        title="Aguarde"
      >
        <p>Salvando OS...</p>
      </modal>
      <subheader
        v-if="isEditMode"
        title="Edição de Ordem de Serviço"
      />
      <subheader
        v-else-if="isRecollect"
        title="Gerar recoleta - confira os dados da recoleta abaixo e clique em salvar"
      />
      <subheader
        v-else
        title="Cadastrar Ordem de Serviço"
      />
      <div class="orders-new__patient width-responsiveness">
        <card-form :collapsed="!isPatientCollapsed">
          <div
            slot="expanded"
            class="form-container"
          >
            <span class="required-fields-label">* Preenchimento obrigatório</span>
            <md-layout
              :md-gutter="24"
              md-flex="100"
            >
              <md-layout
                md-flex="100"
                md-flex-medium="100"
              >
                <h2
                  id="patientFormTitle"
                  class="orders-new__patient__title title-main"
                >
                  Dados do Paciente
                </h2>
              </md-layout>

              <md-layout
                md-flex="30"
                md-flex-medium="65"
              >
                <md-input-container
                  id="patientName"
                  :class="{
                    'md-input-invalid': errors.has('name'),
                    'md-input-disabled': isPatientOS
                  }"
                >
                  <label>Nome do paciente *</label>
                  <md-input
                    id="txtNewPatientName"
                    v-model="patient.name"
                    v-validate="'required'"
                    data-vv-validate-on="none"
                    name="name"
                    maxlength="60"
                    type="text"
                    title
                    placeholder="Nome do paciente *"
                    @keydown.enter.native="focusNextField('txtNewPatientAge')"
                  />
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>

              <md-layout
                md-flex="20"
                md-flex-medium="25"
              >
                <md-input-container
                  id="patientBirthDate"
                  class="datepicker"
                  :class="{
                    'md-input-invalid': errors.has('birthDate'),
                    'md-input-disabled': isPatientOS
                  }"
                >
                  <label> Data de nascimento * </label>
                  <v-date-picker
                    v-model="patient.birthDate"
                    v-mask="'##/##/####'"
                    v-validate="'required|check_date_format:DD/MM/YYYY|not_future_date|after_date:31/12/1899'"
                    :pane-width="290"
                    :tint-color="'#7f1a54'"
                    mode="single"
                    maxlength="10"
                    type="text"
                    placeholder
                    data-vv-validate-on="none"
                    title
                    name="birthDate"
                    is-expanded
                    @blur.native="calculateAge"
                    @keydown.enter.native="focusNextFieldDropdownSexo('patientGender')"
                  >
                    <div slot-scope="{ inputValue, updateValue }">
                      <md-input
                        id="dtNewBirthDate"
                        type="text"
                        :value="inputValue"
                        :placeholder="'Data de nascimento *'"
                        expanded
                        @change.native="
                          {
                            updateValue($event.target.value), changeAge(true)
                          }
                        "
                      />
                    </div>
                  </v-date-picker>
                  <span
                    v-if="errors.firstByRule('birthDate', 'required')"
                    class="md-error"
                  >Obrigatório</span>
                  <span
                    v-else-if="errors.firstByRule('birthDate', 'check_date_format')"
                    class="md-error"
                  >Valor inválido</span>
                  <span
                    v-else-if="errors.firstByRule('birthDate', 'not_future_date')"
                    class="md-error"
                  >Data não pode ser maior que a atual</span>
                  <span
                    v-else-if="errors.firstByRule('birthDate', 'after_date')"
                    class="md-error"
                  >Ano deve ser maior que 1899</span>
                </md-input-container>
              </md-layout>

              <md-layout md-flex="10">
                <md-input-container
                  id="patientAge"
                  :class="{ 'md-input-invalid': errors.has('age') }"
                >
                  <label>Idade</label>
                  <md-input
                    id="txtNewPatientAge"
                    v-model="patient.age"
                    v-validate="'required'"
                    v-mask="'###'"
                    data-vv-validate-on="none"
                    name="age"
                    maxlength="3"
                    type="text"
                    title
                    placeholder="Idade "
                    :disabled="true"
                    @keyup.enter.native="calculateBirthDate()"
                    @blur.native="calculateBirthDate"
                    @change="changeAge(false)"
                    @keydown.enter.native="focusNextField('dtNewBirthDate')"
                  />
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>

              <md-layout
                md-flex="20"
                md-flex-medium="25"
              >
                <md-input-container
                  id="patientGender"
                  name="sexo"
                  :class="{
                    'md-input-placeholder md-advanced-select': true,
                    'md-has-value': patient.gender,
                    'md-input-invalid': errors.has('sexo'),
                    'md-input-disabled': isPatientOS
                  }"
                >
                  <label>Sexo *</label>
                  <advanced-select
                    id="cboNewSex"
                    v-model="patient.gender"
                    v-validate="'required'"
                    :options="genderOptions"
                    placeholder
                    name="sexo"
                    :taggable="false"
                    :searchable="true"
                    data-vv-validate-on="none"
                    title
                  />
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>

              <md-layout md-flex="20">
                <md-input-container
                  id="patientCPF"
                  :class="{
                    'md-input-invalid': errors.has('patient.cpf'),
                    'md-input-disabled': isPatientOS
                  }"
                >
                  <label v-if="cpfRequired">CPF do paciente *</label>
                  <label v-else>CPF do paciente</label>
                  <md-input
                    id="txtPatientCPF"
                    v-model="patient.cpf"
                    v-mask="'###.###.###-##'"
                    v-validate="cpfRequired ? 'required|cpf_valid' : 'cpf_valid'"
                    maxlength="60"
                    type="text"
                    :placeholder="cpfRequired ? 'CPF do paciente *' : 'CPF do paciente'"
                    data-vv-validate-on="none"
                    name="patient.cpf"
                    @keydown.enter.native="focusNextField('txtNewNote')"
                  />
                  <span
                    v-if="errors.firstByRule('patient.cpf', 'cpf_valid')"
                    class="md-error"
                  >CPF Inválido</span>
                  <span
                    v-if="errors.firstByRule('patient.cpf', 'required')"
                    class="md-error"
                  >Obrigatório</span>
                </md-input-container>
              </md-layout>

              <md-layout md-flex="100">
                <md-layout
                  v-if="patient.socialNameEnabled"
                  md-flex="50"
                >
                  <md-input-container
                    id="patientSocialName"
                    :class="{ 'md-input-invalid': errors.has('social_name') }"
                  >
                    <label>Nome social</label>
                    <md-input
                      id="txtPatientSocialName"
                      v-model="patient.social_name"
                      v-validate="'required'"
                      data-vv-validate-on="none"
                      name="social_name"
                      maxlength="60"
                      type="text"
                      title
                      placeholder="Nome Social"
                    />
                    <span class="md-error">Obrigatório</span>
                  </md-input-container>
                </md-layout>

                <md-layout
                  :md-gutter="24"
                  md-flex="50"
                  md-flex-medium="50"
                >
                  <md-switch
                    v-model="patient.socialNameEnabled"
                    class="md-primary"
                  >
                    Possui nome social?
                  </md-switch>
                </md-layout>
              </md-layout>

              <md-layout
                v-if="toggle.biometricData"
                :md-gutter="24"
                class="no-padding"
                md-flex="100"
              >
                <md-layout
                  md-flex="100"
                  md-flex-medium="100"
                  class="collection_data"
                >
                  <h2
                    id="patientFormTitle"
                    class="orders-new__patient__title title-main"
                  >
                    Dados biométricos
                  </h2>
                </md-layout>

                <md-layout md-flex="30">
                  <md-input-container
                    id="heightPacient"
                    :class="{
                      'md-input-invalid': errors.has('height'),
                      'md-input-disabled': isPatientOS
                    }"
                  >
                    <label> Altura * </label>
                    <md-input
                      id="txtPacientHeight"
                      v-model="patient.height"
                      v-validate="'required'"
                      v-mask="['#.## m', '#.# m', '# m']"
                      data-vv-validate-on="none"
                      class="input-altura"
                      name="height"
                      max-lenght="4"
                      :placeholder="placeholderHeight"
                      @focus="changePlaceholderHeight('height')"
                      @blur="removeChangePlaceholderHeight('height')"
                    />
                    <span class="md-error">Obrigatório</span>
                  </md-input-container>
                </md-layout>
                <md-layout md-flex="30">
                  <md-input-container
                    id="weightPacient"
                    :class="{
                      'md-input-invalid': errors.has('weight'),
                      'md-input-disabled': isPatientOS
                    }"
                  >
                    <label> Peso * </label>
                    <md-input
                      id="txtPacientWeight"
                      v-model="patient.weight"
                      v-validate="'required'"
                      v-mask="['###,# kg', '##,# kg', '## kg']"
                      data-vv-validate-on="none"
                      name="weight"
                      max-lenght="4"
                      :placeholder="placeholderWeight"
                      @focus="changePlaceholderHeight('weight')"
                      @blur="removeChangePlaceholderHeight('weight')"
                    />
                    <span class="md-error">Obrigatório</span>
                  </md-input-container>
                </md-layout>

                <md-layout md-flex="30">
                  <md-input-container
                    id="imcPacient"
                    :class="{
                      'md-input-invalid': errors.has('bmi')
                    }"
                  >
                    <label> IMC </label>
                    <md-input
                      id="txtPacientIMC"
                      v-model="patient.bmi"
                      v-validate="'required'"
                      data-vv-validate-on="none"
                      name="bmi"
                      max-lenght="4"
                      :disabled="true"
                      placeholder="IMC"
                    />
                    <span class="md-error">Obrigatório</span>
                  </md-input-container>
                </md-layout>

                <md-layout md-flex="30">
                  <md-input-container
                    id="txtbloodPressureDiastolicPatient"
                    :class="{
                      'md-input-invalid': errors.has('diastolic_blood_pressure')
                    }"
                  >
                    <label> Pressão arterial (diastólica) * </label>
                    <md-input
                      id="txtbloodPressureDiastolic"
                      v-model="patient.diastolic_blood_pressure"
                      v-validate="'required'"
                      v-mask="['### mmHg', '## mmHg']"
                      data-vv-validate-on="none"
                      name="diastolic_blood_pressure"
                      max-lenght="4"
                      :placeholder="placeholderBloodPressure"
                      @focus="changePlaceholderHeight('bloodPressure')"
                      @blur="removeChangePlaceholderHeight('bloodPressure')"
                    />
                    <span class="md-error">Obrigatório</span>
                  </md-input-container>
                </md-layout>
                <md-layout md-flex="30">
                  <md-input-container
                    id="txtBloodPressureSystolicPatient"
                    :class="{
                      'md-input-invalid': errors.has('systolic_blood_pressure')
                    }"
                  >
                    <label> Pressão arterial (sistólica) * </label>
                    <md-input
                      id="txtBloodPressureSystolic"
                      v-model="patient.systolic_blood_pressure"
                      v-validate="'required'"
                      v-mask="['### mmHg', '## mmHg']"
                      data-vv-validate-on="none"
                      name="systolic_blood_pressure"
                      max-lenght="4"
                      :placeholder="placeholderBloodPressureSystolic"
                      @focus="changePlaceholderHeight('bloodPressureSystolic')"
                      @blur="removeChangePlaceholderHeight('bloodPressureSystolic')"
                    />
                    <span class="md-error">Obrigatório</span>
                  </md-input-container>
                </md-layout>

                <md-layout md-flex="30">
                  <md-input-container
                    id="txtAbdominalcircumferencePatient"
                    :class="{
                      'md-input-invalid': errors.has('abdominal_circumference')
                    }"
                  >
                    <label> Circunferência abdominal *</label>
                    <md-input
                      id="txtAbdominalcircumference"
                      v-model="patient.abdominal_circumference"
                      v-validate="'required'"
                      v-mask="['### cm', '## cm']"
                      data-vv-validate-on="none"
                      name="abdominal_circumference"
                      max-lenght="4"
                      :placeholder="placeholderAbdominalCircumference"
                      @focus="changePlaceholderHeight('abdominalCircumference')"
                      @blur="removeChangePlaceholderHeight('abdominalCircumference')"
                    />
                    <span class="md-error">Obrigatório</span>
                  </md-input-container>
                </md-layout>
                <md-layout md-flex="30">
                  <md-checkbox
                    v-model="patient.smoker"
                    class="input_checkbox"
                  >
                    <h3>Fumante</h3>
                  </md-checkbox>
                </md-layout>

                <md-layout md-flex="30">
                  <md-checkbox
                    v-model="patient.diabetic"
                    class="input_checkbox"
                  >
                    <h3>Diabético</h3>
                  </md-checkbox>
                </md-layout>
              </md-layout>

              <md-layout
                md-flex="100"
                md-flex-medium="100"
                class="collection_data"
              >
                <h2
                  id="patientFormTitle"
                  class="orders-new__patient__title title-main"
                >
                  Dados da Coleta
                </h2>
              </md-layout>

              <md-layout
                :md-flex="toggle.covax ? 50 : 30"
                :md-flex-medium="toggle.covax ? 50 : 30"
              >
                <md-input-container
                  id="patientOsIdLis"
                  :class="{ 'md-input-invalid': errors.has('osIdLis') }"
                >
                  <label title="LIS = sistema do laboratório">
                    <template v-if="!toggle.covax">OS LIS</template>
                    <template v-else>Requisition Number</template>
                  </label>
                  <md-input
                    id="txtNewPatientOSLIS"
                    v-model="patient.osIdLis"
                    v-validate="toggle.covax ? 'required' : ''"
                    name="osIdLis"
                    maxlength="30"
                    type="text"
                    :placeholder="toggle.covax ? 'Requisition Number' : 'OS LIS'"
                    :disabled="disableOsIdLis"
                    @keydown.enter.native="focusNextField('txtNewPatientLis')"
                  />
                  <div v-if="!toggle.covax">
                    <md-icon class="cursor-help">
                      info_outline
                    </md-icon>
                    <md-tooltip md-direction="top">
                      Código da solicitação no seu sistema
                    </md-tooltip>
                  </div>
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>

              <md-layout
                v-if="!toggle.covax"
                md-flex="30"
                md-flex-medium="30"
              >
                <md-input-container
                  id="patientIdLis"
                  :class="{ 'md-input-invalid': errors.has('idLis') }"
                >
                  <label title="LIS = sistema do laboratório">ID LIS</label>
                  <md-input
                    id="txtNewPatientLis"
                    v-model="patient.idLis"
                    name="idLis"
                    maxlength="20"
                    type="text"
                    placeholder="ID LIS"
                    :disabled="disableIdLis"
                    @keydown.enter.native="focusNextField('dtNewCollectDate')"
                  />
                  <div>
                    <md-icon class="cursor-help">
                      info_outline
                    </md-icon>
                    <md-tooltip md-direction="top">
                      Código do paciente no seu sistema
                    </md-tooltip>
                  </div>
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>

              <md-layout
                v-if="toggle.fileImport"
                :md-flex="toggle.covax ? 25 : 20"
                :md-flex-medium="toggle.covax ? 25 : 20"
                class="datepicker"
              >
                <v-date-picker
                  v-model="patient.collectDate"
                  v-validate="'check_date_format:DD/MM/YYYY|date_range'"
                  v-mask="'##/##/####'"
                  class="data-coleta"
                  :pane-width="290"
                  :tint-color="'#7f1a54'"
                  mode="single"
                  data-vv-validate-on="none"
                  maxlength="10"
                  title
                  :popover-content-offset="0"
                  name="collectDate"
                  expanded
                  @keydown.enter.native="focusNextField('txtNewCollectHour')"
                >
                  <md-input-container
                    id="patientCollectDate"
                    slot-scope="{ inputValue, updateValue }"
                    :class="{ 'md-input-invalid': errors.has('collectDate') }"
                  >
                    <label>Data da coleta</label>
                    <md-tooltip md-direction="top">
                      Data de coleta: Mínimo 10 dias antes e máximo 15 dias da data atual
                    </md-tooltip>
                    <md-input
                      id="dtNewCollectDate"
                      type="text"
                      :value="inputValue"
                      :placeholder="'Data da coleta'"
                      expanded
                      @change.native="updateValue($event.target.value)"
                    />
                    <md-icon>date_range</md-icon>
                    <span
                      v-if="errors.firstByRule('collectDate', 'check_date_format')"
                      class="md-error"
                    >Valor inválido</span>
                    <span
                      v-if="errors.firstByRule('collectDate', 'date_range')"
                      class="md-error"
                    >Mínimo 10 dias antes e máximo 15 dias após da data atual</span>
                  </md-input-container>
                </v-date-picker>
              </md-layout>

              <md-layout
                v-else
                :md-flex="toggle.covax ? 25 : 20"
                :md-flex-medium="toggle.covax ? 25 : 20"
                class="datepicker"
              >
                <v-date-picker
                  v-model="patient.collectDate"
                  v-validate="'check_date_format:DD/MM/YYYY|date_range'"
                  v-mask="'##/##/####'"
                  class="data-coleta"
                  :pane-width="290"
                  :tint-color="'#7f1a54'"
                  mode="single"
                  data-vv-validate-on="none"
                  maxlength="10"
                  title
                  :popover-content-offset="0"
                  name="collectDate"
                  expanded
                  @keydown.enter.native="focusNextField('txtNewCollectHour')"
                >
                  <md-input-container
                    id="patientCollectDate"
                    slot-scope="{ inputValue, updateValue }"
                    :class="{ 'md-input-invalid': errors.has('collectDate') }"
                  >
                    <label>Data da coleta</label>
                    <md-tooltip md-direction="top">
                      Data de coleta: Mínimo 10 dias antes e máximo 15 dias após da data atual
                    </md-tooltip>
                    <md-input
                      id="dtNewCollectDate"
                      type="text"
                      :value="inputValue"
                      :placeholder="'Data da coleta'"
                      expanded
                      @change.native="updateValue($event.target.value)"
                    />
                    <md-icon>date_range</md-icon>
                    <span
                      v-if="errors.firstByRule('collectDate', 'check_date_format')"
                      class="md-error"
                    >Valor inválido</span>
                    <span
                      v-if="errors.firstByRule('collectDate', 'date_range')"
                      class="md-error"
                    >Mínimo 10 dias antes e máximo 15 dias após da data atual</span>
                  </md-input-container>
                </v-date-picker>
              </md-layout>

              <md-layout
                :md-flex="toggle.covax ? 25 : 20"
                :md-flex-medium="toggle.covax ? 25 : 20"
              >
                <md-input-container
                  id="patientCollectTime"
                  :class="{ 'md-input-invalid': errors.has('collectTime') }"
                >
                  <label>Hora da coleta</label>
                  <md-input
                    id="txtNewCollectHour"
                    v-model="patient.collectTime"
                    v-validate="'date_format:HH:mm'"
                    v-mask="'##:##'"
                    data-vv-validate-on="none"
                    name="collectTime"
                    maxlength="5"
                    type="text"
                    title
                    placeholder="Hora da coleta"
                    @keydown.enter.native="focusNextField('txtNewDoctor')"
                  />
                  <md-icon>query_builder</md-icon>
                  <span
                    v-if="errors.firstByRule('collectTime', 'required')"
                    class="md-error"
                  >Obrigatório</span>
                  <span
                    v-else-if="errors.firstByRule('collectTime', 'date_format')"
                    class="md-error"
                  >Formato de hora inválido</span>
                </md-input-container>
              </md-layout>

              <md-layout
                md-flex="20"
                md-flex-medium="20"
                md-flex-large="20"
              >
                <md-input-container
                  id="patientDoctorId"
                  :class="{
                    'md-input-invalid': errors.has('doctor.id'),
                    'md-input-disabled': isPatientOS
                  }"
                >
                  <label>CRM</label>
                  <md-input
                    id="txtNewCRM"
                    v-model.trim="patient.doctor.id"
                    v-validate="validateDoctorCRM"
                    v-mask="'##########'"
                    maxlength="9"
                    type="text"
                    placeholder="CRM"
                    name="doctor.id"
                    data-vv-validate-on="none"
                    title
                    @change="changeDoctorCrm"
                    @keydown.enter.native="focusNextFieldDropdownUF('patientDoctorState')"
                  />
                  <span
                    v-if="errors.firstByRule('doctor.id', 'required')"
                    class="md-error"
                  >Obrigatório</span>
                  <span
                    v-else-if="errors.firstByRule('doctor.id', 'min')"
                    class="md-error"
                  >Valor inválido</span>
                  <span
                    v-else-if="errors.firstByRule('doctor.id', 'max')"
                    class="md-error"
                  >Valor inválido</span>
                </md-input-container>
              </md-layout>

              <md-layout
                md-flex="20"
                md-flex-medium="20"
                md-flex-large="20"
              >
                <md-input-container
                  id="patientDoctorState"
                  tabindex="11"
                  :disabled="disabledUf"
                  :class="{
                    'md-input-placeholder md-advanced-select': true,
                    'md-has-value': patient.doctor.state,
                    'md-input-invalid': errors.has('doctor.state')
                  }"
                >
                  <label for="UF">UF</label>
                  <advanced-select
                    id="txtNewUF"
                    v-model="patient.doctor.state"
                    v-validate="validateRequiredDoctorFields"
                    :options="stateOptions"
                    placeholder
                    :disabled="disabledUf"
                    :taggable="false"
                    :searchable="true"
                    name="doctor.state"
                    data-vv-validate-on="none"
                    @input="changeUf"
                  />
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>

              <md-layout
                v-if="isPatientOS"
                md-flex="60"
                md-flex-medium="60"
              >
                <DoctorSelect
                  :list="doctors"
                  :patient-id="$route.params.patientid"
                  @update="doctorUpadate"
                />
              </md-layout>

              <md-layout
                v-else
                md-flex="60"
                md-flex-medium="60"
              >
                <md-input-container
                  id="patientDoctorName"
                  :class="{ 'md-input-invalid': errors.has('doctor.name') }"
                >
                  <label>Médico</label>
                  <md-input
                    id="txtNewDoctor"
                    v-model="patient.doctor.name"
                    v-validate="validateRequiredDoctorFields"
                    maxlength="60"
                    :disabled="disabledDoctor"
                    type="text"
                    placeholder="Médico"
                    data-vv-validate-on="none"
                    title
                    name="doctor.name"
                  />
                  <span class="md-error">Obrigatório</span>
                </md-input-container>
              </md-layout>

              <md-layout
                v-if="toggle.collectPlace"
                md-flex="60"
              >
                <md-input-container
                  id="patientCollectionPointName"
                  v-click-outside="collectionPointClickOutsite"
                >
                  <label>Posto de coleta</label>
                  <div class="collect-point-input-wrapper">
                    <md-input
                      id="txtCollectionPointName"
                      v-model="patient.collectionPointName"
                      v-validate
                      class="search-dropdown"
                      maxlength="200"
                      type="text"
                      name="patient.collectionPointName"
                      data-vv-validate-on="none"
                      title
                      placeholder="Pesquisar pelo posto de coleta"
                      @change="handlecollectionPointInputChange()"
                      @keydown.tab.native="focusNextFiedPointList()"
                      @focus="handlecollectionPointInputFocus()"
                    />
                    <spinner
                      v-if="collectionPointIsLoading"
                      class="small search__loading"
                    />
                    <button
                      v-if="collectionPointSelected || createdCollectionPoint"
                      class="clear-collect-post"
                      @click="collectionPointClearInput()"
                    >
                      <img
                        src="/static/images/icon-close.svg"
                        alt="icone-fechar"
                      >
                    </button>
                  </div>

                  <ul
                    v-if="opencollectionPointList"
                    id="listPoint"
                    class="collection-point-list"
                    tabindex="0"
                  >
                    <li
                      v-for="(collectionPoint, index) in filteredArray"
                      :id="'listPointItem' + index"
                      :key="index"
                      :tabindex="index + 1"
                      class="collection-point-name"
                      @click="selectcollectionPoint(collectionPoint.name)"
                      @keydown="nextPointList(collectionPoint.name)"
                    >
                      <span
                        class="collection-point-text"
                        :value="index"
                        v-html="highlightText(collectionPointName, collectionPoint.name)"
                      />
                    </li>
                    <div
                      class="btn-create-collection-point"
                      @click="openModal()"
                    >
                      <span>Cadastrar novo posto de coleta</span>
                    </div>
                  </ul>
                </md-input-container>
              </md-layout>

              <md-layout
                md-flex="60"
                md-flex-medium="30"
                md-flex-large="60"
              >
                <md-input-container id="patientComments">
                  <label>Observação</label>
                  <div
                    class="orders-new__observation-container"
                    @keydown.enter.capture="preventRawEnterFromPropagation"
                  >
                    <md-textarea
                      id="txtNewNote"
                      v-model="patient.comments"
                      v-validate
                      maxlength="250"
                      type="text"
                      name="patient.comments"
                      data-vv-validate-on="none"
                      title
                      placeholder="Observação"
                      @keydown.enter.native="focusNextField('btnNewSubmitPatient')"
                    />
                  </div>
                </md-input-container>
              </md-layout>

              <md-layout md-flex="25">
                <md-button
                  id="btnNewSubmitPatient"
                  class="btn btn-primary orders-new__patient__submit-button submit-button"
                  @click="validateBeforeSubmit"
                >
                  {{ isPatientOS ? 'CONFIRMAR' : 'OK' }}
                </md-button>
              </md-layout>
            </md-layout>
          </div>

          <md-layout
            slot="collapsed"
            class="collapsed-container card-form--collapsed"
            :md-gutter="24"
            md-flex="100"
            @click.native="setEditingPatient"
          >
            <md-layout
              md-flex="100"
              md-flex-medium="100"
            >
              <h2
                id="patientFormTitle"
                class="orders-new__patient__title orders-new__patient__title-collapsed title-main"
              >
                Dados do Paciente
              </h2>
            </md-layout>
            <md-layout
              class="collapsed__item"
              md-flex="20"
            >
              <div class="md-input-container md-theme-default">
                <h3>Código (ID LIS)</h3>
                <p :title="patient.idLis">
                  {{ patient.idLis }}
                </p>
              </div>
            </md-layout>
            <md-layout
              class="collapsed__item"
              md-flex="35"
            >
              <div class="md-input-container md-theme-default">
                <h3>Nome do paciente</h3>
                <p :title="patient.name">
                  {{ patient.name }}
                </p>
              </div>
            </md-layout>
            <md-layout
              class="collapsed__item"
              md-flex="10"
            >
              <div class="md-input-container md-theme-default">
                <h3>Idade</h3>
                <p>{{ patient.age }}</p>
              </div>
            </md-layout>
            <md-layout
              class="collapsed__item"
              md-flex="15"
            >
              <div class="md-input-container md-theme-default">
                <h3>Sexo</h3>
                <p>{{ patient.gender ? patient.gender.label : '' }}</p>
              </div>
            </md-layout>
            <md-layout
              class="collapsed__item"
              md-flex="15"
            >
              <div class="md-input-container md-theme-default">
                <h3>
                  <template v-if="!toggle.covax">
                    Código OS LIS
                  </template>
                  <template v-else>
                    Requisition Number
                  </template>
                </h3>
                <p :title="patient.osIdLis">
                  {{ patient.osIdLis }}
                </p>
              </div>
            </md-layout>
            <p
              id="btnNewEditPatient"
              tabindex="0"
              class="md-icon-button collapsed__list__item__edit-button"
              @click="setEditingPatient"
            >
              <md-icon class="collapsed__list__item__edit-button__icon icon-edit-alt" />
              <md-tooltip
                md-delay="400"
                md-direction="top"
              >
                Editar paciente
              </md-tooltip>
            </p>
          </md-layout>
        </card-form>
      </div>

      <div
        v-if="toggle.profileExam"
        id="examProfile"
        class="orders-new__exam-profile width-responsiveness"
      >
        <h2
          id="examProfileTitle"
          class="orders-new__exam__title"
        >
          Perfil de exames
        </h2>
        <ExamProfileSelect />
      </div>

      <div
        id="examSearchContainer"
        class="orders-new__exam width-responsiveness"
      >
        <h2
          id="examFormTitle"
          class="orders-new__exam__title"
        >
          Exames
        </h2>

        <exams-new
          ref="examsNew"
          :patient="patient"
        />

        <md-layout
          md-flex="100"
          class="orders-new__footer"
        >
          <md-layout md-align="start">
            <md-layout md-flex="40">
              <button
                v-if="isEditingOrder"
                id="btnNewCancel"
                class="btn btn-medium btn-septenary orders-new__exam__cancel-button"
                @click="$router.push({ path: '/orders' })"
              >
                Cancelar
              </button>
              <button
                v-else-if="orderClone"
                id="btnNewCancel"
                class="btn btn-medium btn-septenary orders-new__exam__cancel-button"
                @click="$router.push({ path: '/orders?filterBy=P&filterBy=F' })"
              >
                Cancelar
              </button>
              <button
                v-else
                id="btnNewCancel"
                class="btn btn-medium btn-septenary orders-new__exam__cancel-button"
                @click="$router.push({ path: '/dashboard' })"
              >
                Cancelar
              </button>
            </md-layout>
          </md-layout>

          <md-layout
            v-if="isAllNewExamsFilled && isNewPatientFilled"
            class="endButton"
            md-flex="55"
            md-align="end"
          >
            <button-component
              v-if="!isEditingOrder"
              id="btnNewSaveAndNew"
              class="btn-medium btn-nonenary orders-new__exam__save-reload-button"
              @click="startFinishAction(true)"
            >
              <md-icon
                md-src="/static/images/icon-atualizar.svg"
                class="orders-new__exam__save-reload-button__icon-reload"
              >
                save
              </md-icon>SALVAR e cadastrar novo
            </button-component>
            <button
              id="btnNewSave"
              class="btn btn-medium btn-primary orders-new__exam__save-button"
              @click="startFinishAction(false)"
            >
              <md-icon
                md-src="/static/images/icon-save.svg"
                class="orders-new__exam__save-button__icon-save"
              >
                save
              </md-icon>Salvar
            </button>
          </md-layout>
        </md-layout>
      </div>
    </div>
  </div>
</template>

<script>
import patientService from '@/api/patient'
import doctorService from '@/api/doctor'
import DoctorSelect from '@/components/common/DoctorSelect'
import SubHeader from '@/components/common/SubHeader'
import ExamProfileSelect from '@/components/common/ExamProfileSelect'
import Spinner from '@/components/common/Spinner'
import AdvancedSelect from '@/components/common/AdvancedSelect'
import CollectionPointCreateModal from '@/components/CollectionPoint/CollectionPointCreateModal'
import strings from '@/strings'
import notify from '@/api/notification'
import CardForm from '@/components/common/CardForm'
import ExamsNew from '@/components/Exams/ExamsNew'
import { scrollToElement } from '@/utils/window-utils'
import { mask } from 'vue-the-mask'
import { mapActions, mapGetters } from 'vuex'
import Moment from 'moment'
import fuzzysort from 'fuzzysort'
import { ORDER_STATE_FAIL, ORDER_STATE_PENDING_TRANSMISSION } from '@/enums'
import { clickOutside } from '@/utils/directives'

let pointListI = 0
export default {
  name: 'OrdersNew',
  components: {
    DoctorSelect,
    ExamProfileSelect,
    subheader: SubHeader,
    'advanced-select': AdvancedSelect,
    'card-form': CardForm,
    'collection-point-create-modal': CollectionPointCreateModal,
    spinner: Spinner,
    'exams-new': ExamsNew
  },
  directives: {
    mask: mask,
    'click-outside': {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // here I check that click was outside the el and his children
          if (!(el === event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      }
    },
    clickOutside
  },
  data: () => {
    return {
      isDoctorSelected: false,
      doctors: null,
      isPatientOS: false,
      collectionPointFocus: false,
      createdCollectionPoint: false,
      genderOptions: strings.genders,
      stateOptions: strings.brazilStates,
      collectionPointSelected: false,
      patient: {
        idLis: '',
        name: '',
        age: '',
        cpf: '',
        height: '',
        weight: '',
        bmi: '',
        diastolic_blood_pressure: '',
        systolic_blood_pressure: '',
        collectionPointName: '',
        abdominal_circumference: '',
        smoker: false,
        diabetic: false,
        birthDate: null,
        gender: '',
        osIdLis: '',
        collectDate: null,
        collectTime: '',
        doctor: {
          name: '',
          id: '',
          state: ''
        },
        comments: '',
        social_name: '',
        socialNameEnabled: false
      },
      heightInCM: '',
      isPatientCollapsed: false,
      loadingDataForEditing: false,
      today: null,
      placeholderHeight: 'Altura *',
      placeholderWeight: 'Peso *',
      placeholderBloodPressure: 'Pressão arterial (diastólica) * ',
      placeholderBloodPressureSystolic: 'Pressão arterial (sistólica) * ',
      placeholderAbdominalCircumference: 'Circunferência abdominal *',
      showBiometricFields: false,
      disableOsIdLis: false,
      disableIdLis: false,
      disabledDoctor: true
    }
  },
  computed: {
    ...mapGetters([
      'toggle',
      'collectionPointIsLoading',
      'isAllNewExamsFilled',
      'isNewPatientFilled',
      'profile',
      'isEditingOrder',
      'orderClone',
      'collectionPoints',
      'collectionPointCreateSuccess',
      'toggle'
    ]),
    doctor() {
      return this.patient?.doctor
    },
    cpfRequired() {
      return this.profile.laboratoryTypeOutputResult === 'DIAVERUM'
    },
    opencollectionPointList() {
      if (this.collectionPointFocus && !this.collectionPointSelected) {
        return true
      }
      let hastext = false
      if (this.collectionPointName) {
        hastext = this.collectionPointName.length > 0
      }
      if (!this.collectionPointSelected && hastext && !this.createdCollectionPoint) {
        return true
      }
      return false
    },
    filteredArray() {
      if (this.collectionPointName) {
        if (this.collectionPointName.length > 0) {
          let inputNormalized = this.setNormalize(this.collectionPointName)
          if (this.collectionPoints) {
            var targets = this.collectionPoints.map(collectionPoint => {
              collectionPoint.collecPointNameNormalized = this.setNormalize(collectionPoint.name)
              return collectionPoint
            })
          }

          let result = fuzzysort.go(inputNormalized, targets, {
            keys: ['collecPointNameNormalized'],
            limit: 100,
            allowTypo: true,
            threshold: -10000
          })
          result = result.map(item => {
            item = item.obj
            return item
          })
          return result
        }
      } else {
        return this.collectionPoints
      }
    },
    filteredDoctors() {
      if (this.patient.doctor.name) {
        if (this.patient.doctor.name.length > 0) {
          let inputNormalized = this.setNormalize(this.collectionPointName)
          if (this.doctors) {
            var targets = this.doctors.map(doctor => {
              doctor.doctorNameNormalized = this.setNormalize(doctor.name)
              return doctor
            })
          }

          let result = fuzzysort.go(inputNormalized, targets, {
            keys: ['doctorNameNormalized'],
            limit: 100,
            allowTypo: true,
            threshold: -10000
          })
          result = result.map(item => {
            item = item.obj
            return item
          })
          return result
        }
      } else {
        return this.doctors
      }
    },
    validateRequiredDoctorFields() {
      return !this.isStringFieldEmpty(this.patient.doctor.name) ||
        !this.isStringFieldEmpty(this.patient.doctor.id) ||
        this.patient.doctor.state
        ? 'required'
        : ''
    },
    validateDoctorCRM() {
      let validationRules = ''
      if (this.validateRequiredDoctorFields) {
        validationRules = 'required|min:1|max:10|numeric'
      }
      return validationRules
    },
    collectionPointName: {
      get() {
        return this.patient.collectionPointName
      },
      set(value) {
        let valueNormalized = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        this.patient.collectionPointName = valueNormalized.toUpperCase()
      }
    },
    isRecollect() {
      let isRecollect = false
      if (this.$route.params && this.$route.params.requestid) {
        isRecollect = true
      }
      return isRecollect
    },
    isEditMode() {
      return this.$route.params && this.$route.params.orderid
    },
    disabledUf() {
      return !this.patient?.doctor?.id || this.isPatientOS
    }
  },
  watch: {
    collectionPointName(newval) {
      if (newval) {
        if (newval.length === 0) {
          this.createdCollectionPoint = false
          this.collectionPointSelected = false
        } else {
          let name = this.patient.collectionPointName
          let valueNormalized = name.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          valueNormalized = valueNormalized.replace(/[^\w\s]/gi, '')
          valueNormalized = valueNormalized.toUpperCase()
          valueNormalized = valueNormalized.trimStart()
          valueNormalized = valueNormalized.trimEnd()
          this.patient.collectionPointName = valueNormalized
        }
      }
    },
    $route(to, from) {
      if (this.$route.path === '/orders/new') {
        this.examIsProfile(false)
      }
      this.clearPageData()
    },
    'patient.birthDate': function () {
      this.calculateAge()
    },
    'patient.height': {
      handler(newValue) {
        this.calcIMC()
      },
      deep: true
    },
    'patient.weight': {
      handler(newValue) {
        this.calcIMC()
      },
      deep: true
    }
  },
  mounted() {
    if (this.$route.params.patientid) {
      this.isPatientOS = true
      this.loadPatient(this.$route.params.patientid)
      document.getElementById('mainScroll').scrollTop = 0
    } else {
      this.examIsProfile(false)
    }
    if (this.$route.params.orderid) {
      this.loadEditData()
      document.getElementById('mainScroll').scrollTop = 0
    } else if (this.$route.params.requestid) {
      this.loadRecollectData()
      document.getElementById('mainScroll').scrollTop = 0
    } else if (this.orderClone) {
      this.loadCloneData(this.orderClone)
    } else {
      this.clearExamList()
    }
  },
  beforeDestroy() {
    this.isPatientOS = false
    this.clearAllNewOrderData()
    if (this.$route.params.patientid) {
      this.examIsProfile(false)
    }
  },
  methods: {
    ...mapActions([
      'examIsProfile',
      'collectionPointClearList',
      'getAllCollectionPointList',
      'addPatient',
      'editPatient',
      'createOs',
      'clearAllNewOrderData',
      'getEditOS',
      'setEditingOrder',
      'setOrderShowOff',
      'getRecollectByRequestId',
      'clearExamList',
      'orderCanBeCloned'
    ]),
    doctorUpadate(data) {
      this.patient.doctor = data
    },
    async getDoctor() {
      const { id, state } = this.doctor
      const crm = id
      const uf = state.value

      if (!crm || !uf) return

      try {
        const { data } = await doctorService.getDoctorHelthBodiesByCrmAndUf(crm, uf)

        if (data) {
          const { name, crm, uf } = data
          const newDoctor = {
            name,
            id: crm,
            state: {
              label: uf,
              value: uf
            }
          }

          this.patient.doctor = newDoctor
          this.disabledDoctor = true
        } else {
          this.disabledDoctor = false
        }
      } catch (error) {
        this.disabledDoctor = false
        notify({ title: 'AVISO:', message: error?.response?.data?.message ?? error })
      }
    },
    changeDoctorCrm() {
      const doctor = this.patient.doctor
      this.patient.doctor = {
        ...doctor,
        name: '',
        state: undefined
      }
    },
    changeUf() {
      const doctor = this.patient.doctor
      this.patient.doctor = {
        ...doctor,
        name: '',
      }
      this.getDoctor()
    },
    collectionPointClearInput() {
      this.patient.collectionPointName = ''
      this.collectionPointSelected = false
    },
    highlightText(input, text) {
      text = text.toUpperCase()
      return text
    },
    openModal() {
      const collectionPoint = { collecPointName: this.collectionPointName }
      this.$nextTick(function () {
        this.$refs.collectionPointCreateModal.openModal(collectionPoint)
      })
    },
    setEditingPatient() {
      this.editPatient()
      this.isPatientCollapsed = !this.isPatientCollapsed
    },
    collectionPointClickOutsite() {
      this.collectionPointFocus = false
      if (!this.collectionPointSelected && !this.createdCollectionPoint) {
        this.collectionPointName = ''
      }
    },
    selectcollectionPoint(name) {
      this.patient.collectionPointName = name
      this.collectionPointSelected = true
      pointListI = 0
    },
    calcIMC() {
      if (this.patient.height && this.patient.weight) {
        let getOnlyNumber = /\D/g
        let height =
          typeof this.patient.height === 'string'
            ? parseFloat(this.patient.height.replace(getOnlyNumber, '.'))
            : this.patient.height
        let weight =
          typeof this.patient.weight === 'string'
            ? parseFloat(this.patient.weight.replace(getOnlyNumber, '.'))
            : this.patient.weight
        let imc = 0
        this.heightInCM = 0
        this.heightInCM = height / 100
        imc = weight / (height * height)
        imc = imc.toFixed(2)
        this.patient.bmi = imc
      } else {
        this.patient.bmi = ''
      }
    },
    nextPointList(name) {
      let lastEvent
      window.addEventListener(
        'keydown',
        event => {
          if (event.keyCode === 13) {
            // Tab
            this.selectcollectionPoint(name)
            lastEvent = 13
          }
          if (event.keyCode === 38) {
            // ArrowUp
            pointListI--
            lastEvent = 38
          } else if (event.keyCode === 40 || event.keyCode === 9) {
            // ArrowDown
            pointListI++
            lastEvent = 40
          }
        },
        { once: true }
      )
      setTimeout(() => {
        const id = `listPointItem${pointListI}`
        const el = document.getElementById(id)
        if (el) {
          el.focus()
        } else if (lastEvent === 38) {
          pointListI++
        } else if (lastEvent === 40) {
          pointListI--
        }
        return
      }, 525)
    },
    handlecollectionPointInputChange() {
      if (this.collectionPointSelected) {
        this.collectionPointSelected = false
        this.createdCollectionPoint = false
      }
    },
    handlecollectionPointInputFocus() {
      this.collectionPointFocus = true
      this.collectionPointClearList()
      this.getAllCollectionPointList()
    },
    changeAge(age) {
      if (age) {
        this.patient.age = ''
      } else {
        this.patient.birthDate = ''
      }
    },
    calculateBirthDate() {
      if (this.patient.age && this.patient.birthDate === '') {
        let dateNow = new Date()
        let dateYear = dateNow.getFullYear() - this.patient.age
        let dateMonth = dateNow.getMonth()
        let dateDay = dateNow.getDate()

        dateMonth = dateMonth > 9 ? dateMonth : '0' + dateMonth
        dateDay = dateDay > 9 ? dateDay : '0' + dateDay

        this.patient.birthDate = new Date(dateYear, dateMonth, dateDay)
      }
    },
    calculateAge() {
      if (this.patient.birthDate) {
        let birthDate = this.patient.birthDate
        if (birthDate) {
          let patientAge = this.getYearsFromDate(birthDate)
          if (patientAge >= 0) {
            this.patient.age = Math.floor(patientAge)
          } else {
            this.patient.age = ''
          }
        }
      }
    },
    getYearsFromDate(date) {
      let today = new Date()
      today.setHours(23, 59, 59, 59)
      date.setHours(0, 0, 0, 0)
      let firstDate = Moment(date)
      let secondDate = Moment(today)
      return secondDate.diff(firstDate, 'years', true)
    },
    validateBeforeSubmit(evt) {
      // Abort if user pressed enter + shift
      if (evt && evt.keyCode === 13 && evt.shiftKey) {
        return
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          this.isPatientCollapsed = !this.isPatientCollapsed
          this.analyticsSuccessInsertingPatient()
          this.addPatient(this.patient)
          return
        } else {
          this.analyticsForPatientValidationErrors()
        }

        if (this.errors.items.length) {
          let elementName = this.errors.items[0].field
          let element = ''

          if (elementName === 'sexo') {
            element = document.querySelector('#cboNewSex .multiselect')
          } else {
            element = document.querySelector('[name="' + elementName + '"]')
          }
          scrollToElement(element)
          element.focus()
        }
      })
    },
    analyticsForPatientValidationErrors() {
      let self = this
      this.errors.all().forEach(function (errorMessage) {
        self.$analytics.pushAnalyticsEvent('error-validation', {
          'msg-error': errorMessage
        })
      })
    },
    analyticsSuccessInsertingPatient() {
      if (this.collectionPointName) {
        this.$analytics.pushAnalyticsEvent('ga-event', {
          category: 'Posto de Coleta',
          action: 'Criar Cadastro Manual com Posto de Coleta',
          label: this.collectionPointName
        })
      } else if (this.isEditingOrder) {
        this.$analytics.pushAnalyticsEvent('ga-event', {
          category: 'Cadastro Manual',
          action: 'Editar Ordem de Serviço',
          label: ''
        })
      } else {
        this.$analytics.pushAnalyticsEvent('ga-event', {
          category: 'Cadastro Manual',
          action: 'Criar Cadastro Manual'
        })
      }
    },
    preventRawEnterFromPropagation(event) {
      if (!event.altKey && !event.ctrlKey && !event.shiftKey && !event.metaKey) {
        // Enter without any modifier
        event.preventDefault()
      }
    },
    closeTransferDialog() {
      if (this.$refs.transferModal) {
        this.$refs.transferModal.close()
      }
    },
    openTransferDialog() {
      this.$refs.transferModal.open()
    },
    startFinishAction(reload) {
      this.openTransferDialog()

      let param = {
        id: this.$route.params.orderid,
        isVoucher: false
      }

      if (this.$route.params.requestid) {
        param.recollect = this.$route.params.requestid
      }
      this.createOs(param)
        .then(response => {
          this.closeTransferDialog()
          if (reload && response) {
            this.clearPageData()
          } else if (reload) {
            this.clearPageData()
          } else {
            if (this.isRecollect) {
              this.$router.push({
                path: '/orders',
                query: {
                  q: this.$route.params.requestid,
                  findTypeOrderResultFilter: 'RI'
                }
              })
            } else if (this.$route.query.profile) {
              this.$router.push('/patient-routine?filterBy=P')
            } else {
              this.$router.push(
                '/orders?filterBy=' + ORDER_STATE_PENDING_TRANSMISSION + '&filterBy=' + ORDER_STATE_FAIL
              )
            }
            this.setOrderShowOff(false)
          }
        })
        .catch(error => {
          this.closeTransferDialog()
          if (error.response.status === 400) {
            notify({
              title: 'AVISO:',
              message: error.response.data.message
            })
          } else if (error.response.status === 412) {
            notify({
              title: 'AVISO:',
              message: 'O Registro foi alterado. Por favor, recarregue a página.',
              action: {
                title: 'RECARREGAR',
                handler: this.reload
              }
            })
          } else if (error.response.status === 422) {
            if (error.response.data.code === 'DUPLICATED') {
              let erroMsg =
                (!this.toggle.covax ? 'Código OS LIS' : 'Requisition Number') +
                ' já ' +
                (this.$route.params.orderid ? 'salvo' : 'utilizado') +
                '. Por favor, verifique e tente novamente.'
              notify({
                title: 'AVISO:',
                message: erroMsg
              })
            } else if (
              error.response.data.code === 'EXAM_PATERNITY_SHOULD_BE_UNIQUE' ||
              error.response.data.code === 'EXAM_NOT_FOUND'
            ) {
              notify({
                title: 'AVISO:',
                message: error.response.data.message
              })
            } else {
              notify({
                title: 'AVISO:',
                message: 'Não foi possivel salvar a Ordem de Serviço.'
              })
            }
          }
        })
    },
    isStringFieldEmpty(fieldValue) {
      let isEmpty = false
      if (!fieldValue || fieldValue == null || fieldValue === '') {
        isEmpty = true
      }
      return isEmpty
    },
    fillEditPatient(newPatient) {
      if (newPatient.patient.code_lis) {
        this.disableIdLis = true
      }

      if (newPatient.code_lis) {
        this.disableOsIdLis = true
      }

      this.patient.collectDate = !this.isRecollect ? Moment(newPatient.date, 'DD/MM/YYYY').toDate() : null
      this.patient.collectTime = newPatient.time
      this.patient.osIdLis = newPatient.code_lis || ''
      this.patient.comments = newPatient.notes || newPatient.patient.notes
      this.patient.name = newPatient.patient.name
      this.patient.idLis = newPatient.patient.code_lis || ''
      this.patient.gender = this.genderOptions.filter(gender => gender.value === newPatient.patient.gender)[0]
      this.patient.birthDate = Moment(newPatient.patient.birthdate, 'DD/MM/YYYY').toDate()
      this.patient.cpf = newPatient.patient.cpf
      this.patient.collectionPointName = newPatient.collectionPointName
      if (this.patient.collectionPointName) {
        this.collectionPointSelected = true
      }

      if (newPatient.biometric_data) {
        this.patient.height = newPatient.biometric_data.height || ''
        this.patient.weight = newPatient.biometric_data.weight || ''
        this.patient.bmi = newPatient.biometric_data.bmi || ''
        this.patient.diabetic = newPatient.biometric_data.diabetic || false
        this.patient.abdominal_circumference = newPatient.biometric_data.abdominal_circumference || ''
        this.patient.diastolic_blood_pressure = newPatient.biometric_data.diastolic_blood_pressure || ''
        this.patient.smoker = newPatient.biometric_data.smoker || false
        this.patient.systolic_blood_pressure = newPatient.biometric_data.systolic_blood_pressure || ''
      }

      if (newPatient.doctor) {
        this.patient.doctor.name = newPatient.doctor.name
        this.patient.doctor.id = newPatient.doctor.crm
        this.patient.doctor.state = this.stateOptions.filter(state => state.value === newPatient.doctor.state)[0]
      }

      this.patient.socialNameEnabled = newPatient.patient.social_name ? true : false
      this.patient.social_name = newPatient.patient.social_name
    },
    loadEditData() {
      this.setEditingOrder(true)
      this.loadingDataForEditing = true
      this.getEditOS(this.$route.params.orderid)
        .then(response => {
          let data = response.data
          this.fillEditPatient(data)
          this.calculateAge()
          this.loadingDataForEditing = false
          this.validateBeforeSubmit()
        })
        .catch(() => {
          this.loadingDataForEditing = false
          this.$router.push('/orders?filterBy=' + ORDER_STATE_PENDING_TRANSMISSION + '&filterBy=' + ORDER_STATE_FAIL)
          this.setOrderShowOff(false)
        })
    },
    loadCloneData(id) {
      this.setEditingOrder(false)
      this.loadingDataForEditing = true
      this.getEditOS(id)
        .then(response => {
          this.loadingDataForEditing = false
        })
        .catch(() => {
          this.loadingDataForEditing = false
          this.$router.push('/orders?filterBy=' + ORDER_STATE_PENDING_TRANSMISSION + '&filterBy=' + ORDER_STATE_FAIL)
          this.setOrderShowOff(false)
        })
    },
    loadRecollectData() {
      this.createdCollectionPoint = false
      this.setEditingOrder(true)
      this.loadingDataForEditing = true
      this.getRecollectByRequestId(this.$route.params.requestid)
        .then(response => {
          let data = response.data
          data.patient.birthdate = Moment(data.patient.birthdate, 'YYYY-MM-DD').format('DD/MM/YYYY')
          data.date = Moment(data.createdAt).format('DD/MM/YYYY')
          this.fillEditPatient(data)
          this.calculateAge()
          this.loadingDataForEditing = false
          this.validateBeforeSubmit()
        })
        .catch(() => {
          this.loadingDataForEditing = false
          this.$router.push('/recollects')
          this.setOrderShowOff(false)
        })
    },
    clearPageData() {
      this.createdCollectionPoint = false
      this.patient = {
        idLis: '',
        name: '',
        age: '',
        cpf: '',
        height: '',
        weight: '',
        bmi: '',
        diastolic_blood_pressure: '',
        systolic_blood_pressure: '',
        abdominal_circumference: '',
        smoker: false,
        diabetic: false,
        collectionPointName: '',
        birthDate: null,
        gender: '',
        osIdLis: '',
        collectDate: null,
        collectTime: '',
        doctor: {
          name: '',
          id: '',
          state: ''
        },
        comments: '',
        social_name: ''
      }
      this.isPatientCollapsed = false
      this.clearAllNewOrderData()
      window.scrollTo(0, 0)
      this.setEditingOrder(false)
      this.isPatientOS = false
    },
    reload() {
      window.location.reload()
    },
    focusNextField(id) {
      document.getElementById(id).focus()
    },
    focusNextFiedPointList() {
      setTimeout(() => {
        document.getElementById('listPointItem0').focus()
      }, 250)
    },
    focusNextFieldDropdownSexo(id) {
      document.getElementById(id).focus()
      document.getElementById('cboNewSex').firstElementChild.focus()
    },
    focusNextFieldDropdownUF(id) {
      document.getElementById(id).focus()
      document.getElementById('txtNewUF').firstElementChild.focus()
    },
    setNormalize(string) {
      return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    },
    collectionPostNameUpdate(text) {
      this.createdCollectionPoint = true
      let valueNormalized = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      valueNormalized = valueNormalized.toUpperCase()
      this.collectionPointName = valueNormalized
    },
    loadPatient(id) {
      this.examIsProfile(true)
      this.loadingDataForEditing = true
      patientService.getPatientById(id).then(res => {
        this.loadingDataForEditing = false
        const patient = res.data
        this.doctors = patient.doctor_list
        this.height = patient.height
        this.weight = patient.weight
        this.bmi = patient.bmi
        this.diastolic_blood_pressure = patient.diastolic_blood_pressure
        this.systolic_blood_pressure = patient.systolic_blood_pressure
        this.abdominal_circumference = patient.abdominal_circumference
        this.smoker = patient.smoker
        this.diabetic = patient.diabetic

        // normalize the date
        let birthDate = patient.birthdate
        if (birthDate) {
          let date = birthDate.substr(8, 2)
          let month = birthDate.substr(5, 2)
          let year = birthDate.substr(0, 4)
          birthDate = date + '/' + month + '/' + year
        }

        this.patient.birthDate = Moment(birthDate, 'DD/MM/YYYY').toDate()
        this.patient.name = patient.name
        if (patient.cpf) {
          this.patient.cpf = patient.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
        }
        this.patient.gender = {
          label: patient.gender === 'M' ? 'Masculino' : 'Feminino',
          value: patient.gender
        }

        this.patient.socialNameEnabled = patient.social_name ? true : false
        this.patient.social_name = patient.social_name
      })
    },
    changePlaceholderHeight(field) {
      if (field === 'height') {
        this.placeholderHeight = '00 m'
      } else if (field === 'weight') {
        this.placeholderWeight = '00 kg'
      } else if (field === 'bloodPressureSystolic') {
        this.placeholderBloodPressureSystolic = '000 mmhg'
      } else if (field === 'abdominalCircumference') {
        this.placeholderAbdominalCircumference = '00 cm'
      } else if (field === 'bloodPressure') {
        this.placeholderBloodPressure = '00 mmHg'
      }
    },
    removeChangePlaceholderHeight(field) {
      if (field === 'height') {
        this.placeholderHeight = 'Altura *'
      } else if (field === 'weight') {
        this.placeholderWeight = 'Peso *'
      } else if (field === 'bloodPressureSystolic') {
        this.placeholderBloodPressureSystolic = 'Pressão arterial (sistólica) *'
      } else if (field === 'abdominalCircumference') {
        this.placeholderAbdominalCircumference = 'Circunferência abdominal *'
      } else if (field === 'bloodPressure') {
        this.placeholderBloodPressure = 'Pressão arterial (diastólica) *'
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/mixins';

//Orders New Page Styles
.orders-new_container {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 58px);
  font-family: 'Exo 2', sans-serif !important;

  button {
    font-family: 'Exo 2', sans-serif !important;
  }

  #doctorField {
    position: relative;
    width: 100%;
  }

  .doctor-list {
    width: 100%;
    position: absolute;
    top: 48px;
    background-color: #fff;
    z-index: 1;
    box-shadow: 0px 4px 5px 1px rgba(0, 0, 0, 0.1);
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    width: 100%;
    max-height: 276px;
    overflow: auto;
    overflow-x: hidden;

    &__data {
      display: flex;
      justify-content: space-between;
      flex: 1;
      padding-right: 15px;
      align-items: center;
    }

    &__item {
      font-size: 14px;
      color: #4a4a4a;
      line-height: 26px;
      padding: 10px 16px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;

      &:hover {
        background-color: #ddd;
      }

      &--withou-click {
        background-color: #fff;
      }
    }

    &__new {
      background: rgba(127, 26, 84, 0.05);
      color: #7f1a54;
      padding: 10px 16px;
      cursor: pointer;
    }

    hr {
      border: 1px solid #ebebeb;
    }

    h4 {
      color: #7f1a54;
      text-transform: uppercase;
      line-height: 26px;
      padding: 10px 16px 0;
      font-size: 10px;
      font-weight: 500;
    }

    .btn-bordered {
      padding: 5px 20px;
      border: 2px solid #7f1a54;
      border-radius: 3px;
      color: #7f1a54;
      height: 38px;
      text-transform: uppercase;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0.8px;
      background: #fff;

      &:hover {
        background-color: #7f1a54;
        color: #ffffff;
      }
    }
  }

  .card-form__container {
    transition: min-height 600ms, opacity 600ms;
    opacity: 1;
    min-height: 237px;
    border-radius: 6px;

    .collapsed__list__item__edit-button {
      position: absolute;
      right: 0px;
      margin-top: 3px;
      padding: 10px;
      bottom: 20px;

      &>.md-icon:not(.md-icon-delete) {
        position: static;
        margin: 0;
        line-height: 16px;
        color: #c2c2c2;
      }
    }

    .card-form__delete-button {
      position: absolute;
      top: 5px;
      right: 10px;
      color: #c2c2c2;
    }

    &.card-form--collapsed {
      transition: min-height 600ms, opacity 600ms;
      min-height: 90px;
      cursor: pointer;

      &.exam__container {
        .collapsed__list__item__edit-button {
          position: absolute;
          right: 44px;
          margin-top: 3px;

          &>.md-icon:not(.md-icon-delete) {
            position: static;
            margin: 0;
            line-height: 16px;
            color: #c2c2c2;
          }
        }

        .collapsed__list__item__delete-button {
          position: absolute;
          margin-top: 3px;
          right: 0;
          margin-right: 0px;
          padding: 10px;
          bottom: 20px;

          &>.md-icon {
            top: -4px;
          }
        }
      }

      .submit-button,
      .form-container {
        animation-duration: 700ms;
        animation-name: fadeout;
        display: none;
      }

      .collapsed-container {
        opacity: 1;
        display: flex;
        animation-name: fadein;
        animation-duration: 700ms;

        .collapsed__item {
          .md-input-container {
            flex: 1;
            flex-direction: column;
            margin: 0 15px 0;
            padding-top: 0;

            &:after {
              height: 0;
            }
          }

          h3 {
            font-size: 12px;
            color: #858585;
            font-weight: normal;
            white-space: nowrap;
          }

          p {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 90%;
            color: #303030;
            font-size: 16px;

            &.material {
              text-transform: capitalize;
            }
          }

          input {
            font-size: 16px;
          }
        }
      }
    }

    .form-container {
      animation-name: fadein;
      animation-duration: 700ms;
      display: flex;

      .required-fields-label {
        position: absolute;
        right: 5px;
        top: -30px;
        font-size: 12px;
        color: #a80009;
      }

      .tab-label {
        position: absolute;
        right: 180px;
        top: -30px;
        font-size: 12px;
        color: black;

        strong {
          font-weight: 700;
        }
      }

      .md-layout {
        &.datepicker {
          .data-coleta {
            width: 100%;
          }
        }

        .md-input-container {
          .collect-point-input-wrapper {
            width: 100%;
            position: relative;

            .loader {
              position: absolute;
              top: 5px;
              right: 0;
            }

            .clear-collect-post {
              position: absolute;
              top: 0;
              background-color: transparent;
              right: 0;
              width: auto;
              height: auto;
            }
          }

          .search-dropdown {
            background-image: url('/static/images/icon-search-small.svg');
            background-position: 2px 4px;
            background-repeat: no-repeat;
            padding-left: 35px;
          }

          margin: 0 0 17px;

          .collection-point-list {
            position: absolute;
            top: 48px;
            background-color: #fff;
            z-index: 1;
            box-shadow: 0px 4px 5px 1px rgba(0, 0, 0, 0.1);
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            width: 100%;
            max-height: 276px;
            overflow: auto;
            overflow-x: hidden;

            &:focus-visible {
              outline: none;
            }

            .collection-point-name {
              font-size: 14px;
              color: #4a4a4a;
              line-height: 26px;
              padding: 10px 15px;
              cursor: pointer;

              &:hover {
                background-color: #ddd;
              }

              &:active,
              &:focus {
                background: #ddd !important;
              }

              &:focus-visible {
                outline: none !important;
              }

              .collection-point-text {
                span {
                  font-weight: bold;
                }
              }
            }

            .btn-create-collection-point {
              font-size: 14px;
              color: #7f1a54;
              font-weight: 400;
              line-height: 24px;
              background-color: #f8f3f6;
              padding: 15px;
              cursor: pointer;

              &:hover {
                text-decoration: underline;
              }
            }
          }
        }

        .md-input-disabled,
        .md-input-container[disabled] {
          background: #f4f4f4;
        }
      }

      .md-input-container,
      .md-input-container.md-input-focused {
        .md-icon {
          color: #c2c2c2;
        }
      }

      .multiselect--disabled {
        background: inherit;

        .multiselect__select,
        .multiselect__current {
          background: #f4f4f4;
        }
      }

      .md-input-disabled {
        color: rgba(0, 0, 0, 0.38);
        cursor: not-allowed;

        &.md-has-value {
          label {
            font-size: 12px;
          }
        }

        input,
        .advanced-select__container,
        .advanced-select__container .multiselect__single {
          pointer-events: none;
          color: rgba(0, 0, 0, 0.38);
          font-size: 14px;
        }

        label {
          font-size: 16px;
        }
      }
    }

    .collapsed-container {
      animation-name: fadeout;
      animation-duration: 700ms;
      display: none;
    }
  }

  .orders-new__patient {
    margin-top: 170px;

    .form-container {
      .md-gutter-24:not(.md-column) {
        margin-right: 0;
        margin-left: 0;
      }

      .no-padding {
        padding-left: 0 !important;
      }
    }

    .collapsed-container {
      .collapsed__list {
        display: flex;

        &__item {
          margin: 0 15px 0;

          &:last-child {
            margin-left: 5px;
          }
        }

        .collapsed__title {
          font-size: 12px;
          color: #858585;
          font-weight: normal;
        }

        .collapsed__text {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 16px;
          color: #303030;
          margin-top: 2px;
          letter-spacing: normal;
        }

        input {
          font-size: 16px;
        }
      }
    }

    @media all and (-ms-high-contrast: none) {
      .md-layout {
        .md-layout {
          display: table;
        }
      }
    }

    /* .multiselect__element:nth-child(1) {
        cursor: not-allowed;
        display: none;
      } */

    .advanced-select__container .multiselect__option--selected,
    .advanced-select__container .multiselect__option--selected.multiselect__option--highlight {
      background: white;
      font-weight: bold;
      color: black;
    }

    .advanced-select__container .multiselect__option--highlight {
      background: #ddd !important;
      color: black;
    }
  }

  .orders-new {
    &__exam {
      height: 400px;

      &__save-button {
        width: 182px;

        &__icon-save {
          margin: 0 7px 0 0;
          width: 16px;
          height: 15px;
          min-height: 15px;
          min-width: 16px;
        }
      }

      &__save-reload-button {
        width: 263px;
        margin-right: 20px;

        &__icon-reload {
          margin: 0 7px 0 0;
          width: 16px;
          height: 15px;
          min-height: 15px;
          min-width: 16px;
        }
      }
    }

    &__patient__title {
      margin: 5px 0 5px;

      &-collapsed {
        margin-left: 15px;
      }
    }

    &__exam__title {
      margin: 34px 0 31px;
      font-size: 22px;
      font-weight: 400;
      letter-spacing: -0.3px;
      text-align: left;
      color: #7a7a7a;
      line-height: 1.09;
    }

    &__observation-container {
      width: 100%;

      .md-input {
        overflow-y: hidden !important;
        overflow: hidden;
        -ms-overflow-y: hidden !important;
        max-height: none;
      }
    }

    &__footer {
      margin: 36px 0;

      .endButton {
        flex-wrap: nowrap;
      }
    }
  }

  .advanced-select {
    &__container {
      .multiselect {
        &__single {
          width: 100%;
          color: #303030;
          font-size: 16px;

          @media screen and (-ms-high-contrast: active),
          (-ms-high-contrast: none) {
            margin: 1px 0 0;
          }
        }
      }
    }
  }
}

#createNewDoctorModal {

  .md-dialog-content,
  .md-dialog {
    overflow: inherit;
  }

  .add-doctor__card {
    padding: 20px 0;
    margin-top: 0;
  }
}

@keyframes fadeout {
  0% {
    opacity: 1;
  }

  99% {
    opacity: 0;
  }

  100% {
    display: none;
  }
}

@keyframes fadein {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.send-orders.modals .md-dialog {
  min-width: 660px;
  min-height: 230px;
  border-radius: 7px;

  &-title {
    padding: 32px 34px 13px;
    font-size: 24px;
    font-weight: 300;
    letter-spacing: -0.3px;
    color: rgba(96, 96, 96, 0.87);
  }

  .close-button {
    position: absolute;
    top: 23px;
    right: 38px;
  }

  p {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 18px;
    letter-spacing: -0.2px;
    text-align: center;
    color: #303030;
    margin-bottom: 10px;
  }
}

.orders-new__exam__cancel-button {
  width: 182px;
}

.input_checkbox h3 {
  color: #818181;
  font-weight: 400;
}

.md-theme-default.md-checkbox.md-checked .md-checkbox-container {
  background-color: #7f1a54;
  border-color: #7f1a54;
}

.collection_data {
  margin-top: 25px;
}

@media all and (-ms-high-contrast: none),
(-ms-high-contrast: active) {

  //Prevent z-index overlapping in the patient gender combo
  #patientGender {
    z-index: 3;
  }
}

.IE {
  .new-exam {
    .search-results__exams {
      .exam__container {
        .exam-item__details.md-flex-25 {
          min-width: 17%;
          max-width: 18.3%;
        }
      }
    }
  }

  @media only screen and (max-width: 1024px) {
    .new-exam {
      .search-results__exams {
        .paternity-exam {
          .collapsed__item {
            padding: 0;
          }

          .md-flex-35 {
            min-width: 10%;

            .md-theme-default {
              width: 240px;
              margin-right: 0;
            }
          }
        }

        .exam__container {
          .exam-item__details.md-flex-25 {
            min-width: 17%;
            max-width: 21.7%;
          }
        }
      }
    }

    .orders-new_container .card-form__container.card-form--collapsed .collapsed-container .collapsed__item p {
      width: 100%;
    }
  }
}

.md-input-focused {
  .input-altura {
    &::placeholder {
      &::after {
        content: 'Enter your number';
        position: absolute;
        left: 5px;
        top: 0;
        color: #bbb;
      }
    }
  }
}

#btnNewCancel {
  max-width: 182px;
}
</style>
